import { render, staticRenderFns } from "./ForgotAccount.vue?vue&type=template&id=76866198&"
import script from "./ForgotAccount.vue?vue&type=script&lang=js&"
export * from "./ForgotAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports